<template>
  <div class="content if-profile customize_report report-tab">
    <div class="md-layout profit-loss">
      <MRReportHeader :headerData="this.headerData" />

      <div class="content-checkbox mt-4">
        <div
          class="md-layout-item md-medium-size-100 md-size-100 md-large-size-100 p-0 mt-4"
        >
          <h1 class="section_header">Customize Report</h1>
          <nav-tabs-card>
            <md-tabs md-alignment="left">
              <md-tab
                id="Developer-Client"
                md-label="Client Display (optional)"
                md-icon="arrow_drop_down"
                class="p-0"
              >
                <div class="md-layout">
                  <div class="md-layout-item p-0">
                    <md-card-header>Client Display (optional)</md-card-header>
                    <md-card-content>
                      <div class="md-layout contact-form">
                        <div class="md-layout-item md-size-100 p-0">
                          <div class="md-layout d-flex">
                            <div class="md-layout-item">
                              <label>Client Name:</label>
                            </div>
                            <div class="md-layout-item">
                              <md-field class="input m-0">
                                <md-input
                                  v-model="client_name"
                                  class="form-imput"
                                  placeholder="Input Client Name"
                                ></md-input>
                              </md-field>
                            </div>
                          </div>
                          <!--<div class="md-layout customize-form">
                                                          <div class="md-layout-item choose-img-box">
                                                              <div class="label_wpr">
                                                                  <label>Client Logo:</label>
                                                                  <md-field class="label m-0">
                                                                      <div class="remove-img-box">
                                                                          <img
                                                                              :src="base"
                                                                              alt="Avatar"
                                                                          />
                                                                          <a
                                                                              @click="saveReport('remove', 'clientLogo')"
                                                                              class="close_btn"
                                                                          >
                                                                              <i class="md-icon">close</i>
                                                                          </a>
                                                                      </div>
                                                                  </md-field>
                                                              </div>
                                                          </div>
                                                          <div class="md-layout-item">
                                                              <div class="choose-files-box">
                                                                  <md-field
                                                                      class="choose-file icon-choose-box"
                                                                  >
                                                                      <label
                                                                          v-if="!client_logo"
                                                                      >Choose File</label>
                                                                      <md-file
                                                                          v-model="client_logo"
                                                                          accept="image/*"
                                                                      />
                                                                  </md-field>
                                                                  <p
                                                                      v-if="!client_logo"
                                                                  >No Choose file</p>
                                                              </div>
                                                              <p>
                                                                  (maximum dimensions of 800px x 800px ): PNG, JPG, JEPG,
                                                                  GIF
                                                              </p>
                                                          </div>
                                                      </div>-->
                        </div>
                      </div>
                    </md-card-content>
                  </div>
                </div>
                <div
                  v-if="!isSample"
                  @click="saveReport()"
                  class="md-layout-item md-size-100 submit-box p-0"
                >
                  <md-button
                    :md-ripple="false"
                    class="md-info md-block access-button bottom-check"
                    >Submit</md-button
                  >
                </div>
              </md-tab>
            </md-tabs>
          </nav-tabs-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import MRReportHeader from "./_partials/MRReportHeader.vue";

export default {
  components: {
    MRReportHeader,
  },
  props: ["headerData"],
  data() {
    return {
      ringtone: "peace",
      base: process.env.VUE_APP_API_BASE_URL + "/IFBB_Images/",
      clientFile: null,
      clientLogo: null,
      loading: false,
      developer_name: null,
      developer_phone: null,
      developer_email: null,
      developer_logo: null,
      client_name: null,
      client_logo: null,
      checked: [],
      allChecked: [
        "accounts_payable_business_revenue",
        "ebitda_business_revenue",
        "current_ratio",
        "return_on_assets",
        "quick_ratio",
        "return_on_net_worth",
        "days_payable",
        "return_on_business_revenue",
        "current_liabilities_inventory",
        "discretionary_owner_earnings",
        "net_working_capital",
        "return_on_assets_after_tax",
        "cosPayables",
        "return_on_net_worth_after_tax",
        "cosInventory",
        "return_on_business_revenue_after_tax",
        "assets_business_revenue",
        "interest_coverage",
        "days_inventory",
        "current_liabilities_net_worth",
        "days_receivables",
        "long_term_liabilities_net_worth",
        "current_asset_turnover",
        "loans_notes_payable_net_worth",
        "fixed_asset_turnover",
        "zscore",
        "gross_margin_business_revenue",
        "total_liabilities_net_worth",
        "sales_per_employee",
        "fixedAssetsNetWorth",
        "invTurnover",
        "arTurnover",
        "totalAssetTurnover",
        "workingCapitalTurnover",
        "daysWorkingCapital",
        "cashTurnover",
        "efficiency_index",
        "profit_employee",
        "owner_earnings_employee",
      ],
      placeholder: null,
    };
  },
  computed: {
    ...mapState({
      inputFields: (state) => state.user.market_report.data.inputFields,
      companyClientName: (state) =>
        state.user.market_report.data.coverPage
          ? state.user.market_report.data.coverPage.client_text
          : "",
      companyClientLogo: (state) =>
        state.user.market_report.data.coverPage
          ? state.user.market_report.data.coverPage.client_img
          : "",
      ratioOutput: (state) => state.user.report.ratioOutput,
      clientInfo: (state) => state.user.market_report.data.coverPage,
    }),
    leftRatioOutput() {
      return this.ratioOutput.map((ratio) => ratio.left);
    },
    rightRatioOutput() {
      return this.ratioOutput.map((ratio) => ratio.right);
    },
    isSample() {
      return this.$route.path.indexOf("sample") > -1;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    ...mapActions({
      save: "user/saveReport",
      getReport: "user/getReport",
      alertSuccess: "alerts/success",
      alertError: "alerts/error",
      updatePullTime: "tracking/updatePullTime",
    }),
    init() {
      this.client_name = this.companyClientName;
      this.client_logo = this.companyClientLogo;
    },
    checkUncheck(isChecked) {
      this.ratioOutput.forEach(({ left, right }) => {
        if (left.id || right.id) {
          if (isChecked) {
            if (left.id) this.checked.push(left.id);
            if (right.id) this.checked.push(right.id);
          } else {
            if (this.checked.includes(left.id))
              this.checked = this.checked.filter((i) => i !== left.id);
            if (this.checked.includes(right.id))
              this.checked = this.checked.filter((i) => i !== right.id);
          }
        }
      });
    },
    onFileUpload(event) {
      this.developer_logo = event;
    },
    saveReport(action = "save", logo) {
      // action: clear/remove/save
      this.loading = true;
      let params = {};

      if (action === "save") {
        // params.data = [...this.checked];
        params.data = this.inputFields;
        params.client_name = this.client_name || null;
        params.client_logo = this.client_logo || null;
      }

      if (action === "remove") {
        params.data = logo;
      }

      params = _.omitBy(params, _.isEmpty);

      this.save({
        report_id: this.$route.params.id,
        profile_id: this.$route.params.id,
        type: "imr",
        action: action,
        ...params,
      })
        .then((res) => {
          this.alertSuccess("Data loaded.");
          this.$router.push({
            name: "MRAboutTheData",
            params: this.$route.params.id,
          });
          this.$router.go();
        })
        .catch((err) => {
          this.alertError("An error occurred. We have been notified.");
        })
        .finally(() => {
          this.loading = false;
          this.updatePullTime({
            isFinishedDate: true,
            productId: this.$route.params.id,
          });
        });
    },
    onCompanyChange(event) {
      let files = event.target.files || event.dataTransfer.files;
      if (!files.length) return;
      this.createCompanyImage(files[0]);
    },
    createCompanyImage(file) {
      let reader = new FileReader();
      reader.onload = (e) => {
        this.clientLogo = e.target.result;
        this.clientFile = file;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
<style lang="scss" scoped>
.content-checkbox {
  .contact-box {
    padding: 20px 0 0 20px !important;
  }

  .customize-report-year {
    color: #3b7ef1;

    .full-control {
      .md-list {
        max-width: 100%;
        height: 400px;
        display: inline-block;
        overflow: auto;
        border: 1px solid rgba(#000, 0.12);
        vertical-align: top;
      }
    }
  }

  .md-ripple {
    width: 200px !important;

    span {
      position: inherit !important;
      font-size: 0.9625rem;
      color: #3c4858;
      font-weight: 300;
    }

    .title-box {
      align-items: center !important;
      color: #3b7ef1;
    }
  }

  .check-all {
    border-top: 1px solid !important;
    border-top-color: #ddd !important;
  }

  .checkbox-customize {
    display: flex !important;
    justify-content: space-between !important;
    border-bottom: 1px solid !important;
    border-bottom-color: #ddd !important;

    .bottom-check {
      cursor: pointer;
      background-color: #3b7ef1;
      font-size: 12px;
      font-weight: 400;
      color: #fff;
      width: auto !important;
      margin-left: 10px;
    }
  }

  .md-list-item-container {
    width: 350px !important;
  }

  .title-text {
    color: #3b7ef1;
  }

  .choose-files-box {
    display: flex;
    align-items: center;

    p {
      margin: 0 0 0 10px;
    }

    .choose-file::v-deep {
      background-color: #e3e4e5;
      width: 120px;
      border-radius: 3px;
      padding: 0;
      margin: 0;
      align-items: center;

      label {
        margin-right: 11px;
        position: absolute;
        left: 24px;
        top: 9px;
      }

      i {
        display: none;
      }
    }
  }

  .choose-img-box {
    display: flex;
    align-items: center;

    img {
      width: 80px;
      height: 55px;
    }
  }

  .md-collapse-content {
    padding: 0 !important;
  }

  .md-collapse-title {
    font-size: 18px;
    font-weight: 500;
    letter-spacing: 0.005em;
    line-height: 16px;
  }
}

.icon-choos-box {
  .md-icon {
    display: none !important;
  }
}

h4.main-street {
  padding-top: 0;
}

.financal-report-col-3 {
  display: flex;
  justify-content: flex-end;
}

.submit-box {
  display: flex;
  justify-content: flex-end;

  button {
    background-color: #3b7ef1 !important;
  }
}

.remove-img-box {
  display: flex;
  align-items: center;
}
</style>
